export default __webpack_public_path__ + "static/media/style.e8234d35.less";